import { render, staticRenderFns } from "./save-modal.vue?vue&type=template&id=709eb36d"
import script from "./save-modal.vue?vue&type=script&lang=js"
export * from "./save-modal.vue?vue&type=script&lang=js"
import style0 from "./save-modal.vue?vue&type=style&index=0&id=709eb36d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports